import React from "react";
import "./messageBanner.css";
import PropTypes from "prop-types";

const MessageBanner = ({ messageArray }) => {
  const manageMessages = (messageArray) => {
    return messageArray.map((message) => {
      return <p key={message}>{message}</p>;
    });
  };

  return <div className="message-wrapper">{manageMessages(messageArray)}</div>;
};
MessageBanner.propTypes = {
  messageArray: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MessageBanner;
